module.exports = __webpack_public_path__ + "img/Cover-Teaservideo.1b449fc5.jpg";